export default class UserErrors {
  static wrongEmail = "user/wrong-email";
  static wrongPassword = "user/wrong-password";
  static tooManyFailedLoginAttempts = "user/too-many-failed-logins";
  static networkUnavailable = "user/network-unavailable";
}